import React, { useState } from 'react';
import { Check, ChevronLeft, ChevronRight } from 'lucide-react';
import { useRevealOnScroll } from '../../hooks/useRevealOnScroll';
import { useLanguage } from '../../i18n/LanguageContext';
const WHATSAPP_URL = 'https://wa.me/77010346443?text=%D1%85%D0%BE%D1%87%D1%83%20%D0%B4%D0%B5%D0%BC%D0%BE%20Meelo';
const MODULE_NUMBERS = ['02', '03', '04', '05'];
function CtaPair() {
  const {
    t
  } = useLanguage();
  return <div className="mt-8 flex flex-col sm:flex-row items-start gap-3" data-id="element-212">
      <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center px-8 py-3 rounded-full bg-[#7C4DFF] text-white font-medium text-base shadow-lg hover:bg-[#651FFF] transition-all" data-id="element-213">
        {t('dashboard.cta_more')}
      </a>
      <span className="inline-flex items-center px-5 py-2.5 rounded-full text-sm font-medium text-gray-600 bg-gray-100 border border-gray-200" data-id="element-214">
        {t('dashboard.price')}
      </span>
    </div>;
}
function DesktopGallery({
  images,
  title
}: {
  images: string[];
  title: string;
}) {
  const [active, setActive] = useState(0);
  const prev = () => setActive(i => (i - 1 + images.length) % images.length);
  const next = () => setActive(i => (i + 1) % images.length);
  return <div data-id="element-215">
      <div className="rounded-2xl shadow-2xl border border-gray-200 overflow-hidden bg-white group relative" data-id="element-216">
        <div className="h-8 bg-gray-50 border-b border-gray-100 flex items-center px-4 space-x-2" data-id="element-217">
          <div className="w-3 h-3 rounded-full bg-red-400" data-id="element-218" />
          <div className="w-3 h-3 rounded-full bg-yellow-400" data-id="element-219" />
          <div className="w-3 h-3 rounded-full bg-green-400" data-id="element-220" />
        </div>
        <div className="relative" data-id="element-221">
          {images.map((src, i) => <img key={i} src={src} alt={`${title} — экран ${i + 1}`} className="w-full h-auto block" style={{
          position: i === 0 ? 'relative' : 'absolute',
          top: 0,
          left: 0,
          opacity: active === i ? 1 : 0,
          transition: 'opacity 250ms ease',
          pointerEvents: active === i ? 'auto' : 'none'
        }} data-id="element-222" />)}
          <button onClick={prev} aria-label="Предыдущий экран" className="absolute left-2 top-1/2 -translate-y-1/2 z-10 w-8 h-8 rounded-full bg-white/70 border border-gray-200 flex items-center justify-center text-gray-600 opacity-40 hover:opacity-100 transition-opacity md:opacity-0 md:group-hover:opacity-90 shadow-sm" data-id="element-223">
            <ChevronLeft size={16} data-id="element-224" />
          </button>
          <button onClick={next} aria-label="Следующий экран" className="absolute right-2 top-1/2 -translate-y-1/2 z-10 w-8 h-8 rounded-full bg-white/70 border border-gray-200 flex items-center justify-center text-gray-600 opacity-40 hover:opacity-100 transition-opacity md:opacity-0 md:group-hover:opacity-90 shadow-sm" data-id="element-225">
            <ChevronRight size={16} data-id="element-226" />
          </button>
        </div>
      </div>
      <div className="flex justify-center gap-2 mt-3" data-id="element-227">
        {images.map((_, i) => <button key={i} onClick={() => setActive(i)} aria-label={`Экран ${i + 1}`} style={{
        width: 8,
        height: 8,
        borderRadius: '50%',
        border: 'none',
        cursor: 'pointer',
        padding: 0,
        background: active === i ? '#7C4DFF' : '#D1D5DB',
        transition: 'background 200ms ease'
      }} data-id="element-228" />)}
      </div>
    </div>;
}
function FeatureVisual({
  feature
}: {
  feature: any;
}) {
  if (feature.type === 'mobile') {
    return <div className="rounded-3xl bg-gradient-to-br from-[#F3EEFF] via-[#EDE7F6] to-[#F8F5FF] flex items-center justify-center p-8 lg:p-12 min-h-[420px] lg:min-h-[500px]" data-id="element-229">
        <div className="relative w-full flex items-end justify-center" style={{
        height: 420
      }} data-id="element-230">
          {/* Back phone */}
          <img src="https://cdn.magicpatterns.com/uploads/72Lf8Yrm1xA7wzLU6cnKZw/Mockuuups_Free_Transparent_iPhone_Air_Mockup.png" alt="Трансляция" style={{
          position: 'absolute',
          bottom: 0,
          left: '50%',
          transform: 'translateX(-110%) rotate(-5deg)',
          height: 340,
          width: 'auto',
          objectFit: 'contain',
          opacity: 0.85,
          filter: 'drop-shadow(0 8px 24px rgba(0,0,0,0.25))',
          zIndex: 1
        }} data-id="element-231" />
          {/* Front phone */}
          <img src="https://cdn.magicpatterns.com/uploads/m64wkFNvbCAXCjaTobC78V/Mockuuups_Free_Transparent_iPhone_Air_Mockup.png" alt="Лента дня" style={{
          position: 'absolute',
          bottom: 0,
          left: '50%',
          transform: 'translateX(-30%)',
          height: 400,
          width: 'auto',
          objectFit: 'contain',
          filter: 'drop-shadow(0 16px 40px rgba(124,77,255,0.25))',
          zIndex: 2
        }} data-id="element-232" />
        </div>
      </div>;
  }
  if (feature.images && feature.images.length > 0) {
    return <DesktopGallery images={feature.images} title={feature.title} data-id="element-233" />;
  }
  return <div className="rounded-2xl shadow-2xl border border-gray-200 overflow-hidden bg-white" data-id="element-234">
      <div className="h-8 bg-gray-50 border-b border-gray-100 flex items-center px-4 space-x-2" data-id="element-235">
        <div className="w-3 h-3 rounded-full bg-red-400" data-id="element-236" />
        <div className="w-3 h-3 rounded-full bg-yellow-400" data-id="element-237" />
        <div className="w-3 h-3 rounded-full bg-green-400" data-id="element-238" />
      </div>
      <img src={feature.image} alt={feature.title} className="w-full h-auto" data-id="element-239" />
    </div>;
}
// Wrapper that applies reveal animation to each visual
function RevealVisualWrapper({
  children,
  delay
}: {
  children: React.ReactNode;
  delay: number;
}) {
  const ref = useRevealOnScroll<HTMLDivElement>(delay, 0.15);
  return <div ref={ref} className="reveal-visual visual-hover-lift" data-id="element-240">
      {children}
    </div>;
}
export function SolutionSection() {
  const {
    t
  } = useLanguage();
  const features = [{
    label: t('solutions.label_method'),
    title: t('solutions.title_method'),
    description: t('solutions.desc_method'),
    bullets: [t('solutions.bullet_method_1'), t('solutions.bullet_method_2'), t('solutions.bullet_method_3')],
    image: 'https://cdn.magicpatterns.com/uploads/cSfFjs1QLaFkjpprBaUn8D/журналы.png',
    images: ['https://cdn.magicpatterns.com/uploads/8BE9aBQxMzEdYJY4P1zUS9/Screenshot_2026-02-18_at_23.32.30.png', 'https://cdn.magicpatterns.com/uploads/8XVKzRYhgkqPVgs8v3V9st/Screenshot_2026-02-19_at_11.01.39.png', 'https://cdn.magicpatterns.com/uploads/qxeU4Ka2BGZ9SbhaMdQ8hh/Screenshot_2026-02-19_at_11.02.29.png'],
    type: 'desktop' as const
  }, {
    label: t('solutions.label_food'),
    title: t('solutions.title_food'),
    description: t('solutions.desc_food'),
    bullets: [t('solutions.bullet_food_1'), t('solutions.bullet_food_2'), t('solutions.bullet_food_3'), t('solutions.bullet_food_4')],
    image: 'https://cdn.magicpatterns.com/uploads/wGEXkWBfz5D1U5Hv1vr71s/склад.png',
    images: undefined,
    type: 'desktop' as const
  }, {
    label: t('solutions.label_finance'),
    title: t('solutions.title_finance'),
    description: t('solutions.desc_finance'),
    bullets: [t('solutions.bullet_finance_1'), t('solutions.bullet_finance_2'), t('solutions.bullet_finance_3'), t('solutions.bullet_finance_4')],
    image: 'https://cdn.magicpatterns.com/uploads/oXtJB5vYaQnWngUE2my9vs/скрин_оплаты.png',
    images: undefined,
    type: 'desktop' as const
  }, {
    label: t('solutions.label_parents'),
    title: t('solutions.title_parents'),
    description: t('solutions.desc_parents'),
    bullets: [t('solutions.bullet_parents_1'), t('solutions.bullet_parents_2'), t('solutions.bullet_parents_3'), t('solutions.bullet_parents_4'), t('solutions.bullet_parents_5')],
    image: 'https://cdn.magicpatterns.com/uploads/wVYfLqSbNxSAENx5XfTiKV/мокап_лента_дня.png',
    images: undefined,
    type: 'mobile' as const
  }];
  return <section className="relative pt-0 pb-24 overflow-hidden" style={{
    background: 'linear-gradient(180deg, #6E3EF0 0%, #6538E0 100%)'
  }} data-id="element-241">
      {/* Subtle background blob */}
      <div className="absolute inset-0 pointer-events-none overflow-hidden" aria-hidden="true" data-id="element-242">
        <div style={{
        position: 'absolute',
        top: '40%',
        right: '-8%',
        width: 450,
        height: 450,
        borderRadius: '50%',
        background: 'radial-gradient(circle, rgba(255,255,255,0.05) 0%, transparent 70%)',
        filter: 'blur(70px)'
      }} data-id="element-243" />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-244">
        <div className="space-y-6" data-id="element-245">
          {features.map((feature, index) => {
          const isReversed = index % 2 !== 0;
          return <div key={index} className="rounded-3xl border border-gray-100 bg-white shadow-xl overflow-hidden" data-id="element-246">
                {/* Module header bar */}
                <div className="px-6 py-3 border-b border-gray-100 flex items-center gap-3" data-id="element-247">
                  <span className="text-xs font-bold text-gray-300 tracking-widest font-mono" data-id="element-248">
                    {MODULE_NUMBERS[index]} / 05
                  </span>
                  <span className="text-xs font-semibold tracking-widest uppercase text-[#7C4DFF]/70" data-id="element-249">
                    {feature.label}
                  </span>
                </div>

                {/* Module content */}
                <div className="p-6 lg:p-10" data-id="element-250">
                  <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center lg:min-h-[520px]" data-id="element-251">
                    <div className={isReversed ? 'lg:order-2' : 'lg:order-1'} data-id="element-252">
                      <h3 className="text-2xl md:text-3xl lg:text-4xl font-bold text-[#1A1A2E] leading-tight mb-4" data-id="element-253">
                        {feature.title}
                      </h3>
                      <p className="text-gray-600 text-base lg:text-lg leading-relaxed mb-6 max-w-lg" data-id="element-254">
                        {feature.description}
                      </p>
                      <ul className="space-y-3" data-id="element-255">
                        {feature.bullets.map((bullet, idx) => <li key={idx} className="flex items-center gap-3" data-id="element-256">
                            <div className="flex-shrink-0 w-5 h-5 rounded-full bg-green-100 flex items-center justify-center" data-id="element-257">
                              <Check className="w-3 h-3 text-green-600" strokeWidth={3} data-id="element-258" />
                            </div>
                            <span className="text-gray-700 font-medium text-sm lg:text-base" data-id="element-259">
                              {bullet}
                            </span>
                          </li>)}
                      </ul>
                      <CtaPair data-id="element-260" />
                    </div>

                    <div className={isReversed ? 'lg:order-1' : 'lg:order-2'} data-id="element-261">
                      <RevealVisualWrapper delay={index * 60} data-id="element-262">
                        <FeatureVisual feature={feature} data-id="element-263" />
                      </RevealVisualWrapper>
                    </div>
                  </div>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}